// extracted by mini-css-extract-plugin
export default {"card":"koa-z"};